/**
 * @usedBy ThfPageLoginComponent
 *
 * @description
 *
 * *Enum* para definiÃ§Ã£o do tipo de autenticaÃ§Ã£o.
 */
export enum ThfPageLoginAuthenticationType {

  /** AutenticaÃ§Ã£o Basic */
  Basic = 'Basic',

  /** AutenticaÃ§Ã£o Bearer */
  Bearer = 'Bearer',

}
